<template>
    <div>
        <ul class="categories__list" :class="{'sparse' : model.Items.length <= 4 }">
            <li v-for="item in model.Items">
                <a :href="item.Link.Url" :target="item.Link.Target">
                    <img :data-src="item.Image" :alt="item.ImageAlt">
                    <div class="categories__title">{{item.Link.Name}}</div>
                </a>
            </li>
        </ul>
        <div class="categories__btns" v-if="model.Button != null">
            <a :href="model.Button.Url" :target="model.Button.Target" class="button button_stroke">{{model.Button.Name}}</a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            model: Object
        },
        data() {
            return {
                selected: 0
            }
        },
        updated() {
        },
        methods: {
        },
        mounted() {
            window.lazyLoad.update()
        }
    }
</script>